import PropTypes from 'prop-types';

const insuranceShape = PropTypes.shape({
  cancelled: PropTypes.bool,
  passenger: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  policyNumber: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.number,
  description: PropTypes.string
});

export default insuranceShape;
